var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewInvoice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V17.931H7.42861L8.80792 16.5517H1.37931V1.37931H8.27586V5.51724H12.4138V9.26724C12.8503 9.11207 13.3124 9.01475 13.7931 8.98303V4.54203L9.25108 0H0ZM9.65517 2.35453L11.4386 4.13793H9.65517V2.35453ZM3.44828 7.58621V8.96552H10.3448V7.58621H3.44828ZM3.44828 10.3448V11.7241H10.3448V10.3448H3.44828ZM14.1379 10.3448C12.069 10.3448 10.3448 12.069 10.3448 14.1379C10.3448 14.9655 10.6207 15.6549 11.0345 16.2756L8.27586 19.0342L9.24165 20L12.0003 17.2414C12.621 17.6552 13.3793 17.931 14.1379 17.931C16.2069 17.931 17.931 16.2069 17.931 14.1379C17.931 12.069 16.2069 10.3448 14.1379 10.3448ZM14.1379 11.7241C15.4483 11.7241 16.5517 12.8276 16.5517 14.1379C16.5517 15.4483 15.4483 16.5517 14.1379 16.5517C12.8276 16.5517 11.7241 15.4483 11.7241 14.1379C11.7241 12.8276 12.8276 11.7241 14.1379 11.7241ZM3.44828 13.1034V14.4828H7.58621V13.1034H3.44828Z",
    fill: "#0D1D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewInvoice);
export default __webpack_public_path__ + "static/media/view_invoice.4d95acd608707ab2f497fa7d553db87d.svg";
export { ForwardRef as ReactComponent };